import { Button, Tooltip } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons"

const BaseAddNew = (props) => {
  let text = 'Create New'

  let icon = <PlusCircleOutlined />;
  let notify = props.notify;

  const className = props.className ? `add-new-button ${props.className}` : 'add-new-button';

  return (
    <Tooltip { ...notify } title={ text } className="text-primary">
      <Button icon={ icon } { ...props } className={ className } style={ props.style } >
      </Button>
    </Tooltip>
  );
};

export default BaseAddNew;
